import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'checkmark-icon',
  templateUrl: './checkmark-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CheckmarkIconComponent {}
